import React from 'react';
import { useAnalyticsEvents } from '@atlassian/jira-product-analytics-bridge';
import type { ObjectViewProps } from './common/types.tsx';
import { ObjectViewContainer } from './common/ui/object-view-container/index.tsx';
import { InsightObjectView } from './ui/index.tsx';

const ObjectView = (props: ObjectViewProps) => {
	const {
		workspaceId,
		objectId,
		initialObjectDetailsData,
		backButton,
		context,
		onClone,
		onDelete,
		onUpdate,
		redirectOnDelete,
		showFullBreadcrumbTrail,
		onFinishLoading,
	} = props;
	const { createAnalyticsEvent } = useAnalyticsEvents();
	return (
		<ObjectViewContainer
			objectId={objectId}
			workspaceId={workspaceId}
			initialObjectDetailsData={initialObjectDetailsData}
			createAnalyticsEvent={createAnalyticsEvent}
			onUpdate={onUpdate}
		>
			<InsightObjectView
				context={context}
				backButton={backButton}
				onClone={onClone}
				onDelete={onDelete}
				onFinishLoading={onFinishLoading}
				redirectOnDelete={redirectOnDelete}
				showFullBreadcrumbTrail={showFullBreadcrumbTrail}
			/>
		</ObjectViewContainer>
	);
};

export default ObjectView;
